// Mapa único dos 6 passos do setup do Polaris AI (spec 2026-10-08 §4.2): chave do setup_status → rota da página.
// Usado pelo Get started (checklist), pela SetupProgressBar (Voltar/Avançar) e pelo PageLayout (onde a barra aparece).
export const SETUP_STEP_KEYS = [
  'playbook',
  'knowledge',
  'guidance',
  'integrations',
  'test',
  'deploy',
];

export const SETUP_STEP_ROUTES = {
  playbook: 'polaris_assistants_scenarios_index',
  knowledge: 'polaris_assistants_documents_index',
  guidance: 'polaris_assistants_guidelines_index',
  integrations: 'polaris_tools_index',
  test: 'polaris_assistants_playground_index',
  deploy: 'polaris_assistants_inboxes_index',
};

// Páginas que são um passo do setup (a barra "Passo N de 6" aparece nelas): as rotas do mapa mais as subpáginas
// dos mesmos passos (FAQs e guardrails são Conhecimento/Orientações).
export const SETUP_STEP_ROUTE_NAMES = new Set([
  ...Object.values(SETUP_STEP_ROUTES),
  'polaris_assistants_responses_index',
  'polaris_assistants_responses_pending',
  'polaris_assistants_guardrails_index',
]);
